class PinterestAnalytics {
  clientThankYou(order) {
    this._trigger(order.campaign.pixels.campaign);

    if (order.campaign.pixels.campaign.pinterest !== order.campaign.pixels.global.pinterest) {
      this._trigger(order.campaign.pixels.global);
    }
  }

  _trigger(pixels) {
    if (pixels.pinterest) {
      window.dataLayer.push({ 'clientPinterestPixelId': pixels.pinterest });
      window.dataLayer.push({ 'event': 'client-pinterest-tracking' });
    }
  }
}

export default new PinterestAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/pinterest.js